import React from 'react';
import AuthService from './authService.js';
import { saveAs } from 'file-saver';
import dateTimeHelper from '../Helpers/datetimeHelper.js';
import ErrorMessage from '../Elements/ErrorMessage.js';

class TimesheetExportService extends React.Component {
  static GetTimesheetReport(startDate, endDate, leadId, clientId, opportunityId, projectId, tpProjectId) {
    var authService = AuthService.getInstance();
    var useremail = authService.GetLoggedInUser().email;
    var user = useremail.substr(0, useremail.indexOf('@'));
    var filename =
      'TimesheetReport_' +
      user +
      '_' +
      dateTimeHelper.toYYYYsMMsDD(startDate).replaceAll('-', '') +
      '-' +
      dateTimeHelper.toYYYYsMMsDD(endDate).replaceAll('-', '') +
      '.xlsx';

    var url = '/api/TimesheetReport';
    url +=
      '?userId=' +
      authService.GetLoggedInUser().userId +
      '&startDateTime=' +
      dateTimeHelper.toYYYYsMMsDDsHHsMM(startDate) +
      '&endDateTime=' +
      dateTimeHelper.toYYYYsMMsDDsHHsMM(endDate);

    if (leadId && leadId !== -1) url += '&leadId=' + leadId;

    if (clientId && clientId !== -1) url += '&clientId=' + clientId;

    if (opportunityId && opportunityId !== -1) url += '&opportunityId=' + opportunityId;

    if (projectId && projectId !== -1) url += '&cfId=' + projectId;

    if (tpProjectId && tpProjectId !== -1) url += '&projectId=' + tpProjectId;

    // Get offset from UTC time
    const now = new Date();
    url += '&offsetMinutes=' + now.getTimezoneOffset();

    authService
      .CallBackendFunction(url)
      .then((textResult) => {
        const byteCharacters = atob(textResult);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        saveAs(
          new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          filename
        );
      })
      .catch(() => ErrorMessage.SetErrorMessage('TES48'));
  }
}

export default TimesheetExportService;
